module.exports = __webpack_public_path__ + "img/ic-dropdown.173b3e01.svg";